module.exports = __webpack_public_path__ + "img/107vs36.32a6b834.png";